<template>
  <div>
    <v-layout wrap>
      <v-flex xs6>
        <v-btn flat color="primary" @click="$emit('back')">
          <em class="fas fa-chevron-left mr-2" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-btn dark outline color="primary" @click="downloadImportTemplate">
          <em class="fas fa-download" />&nbsp;Download template
        </v-btn>
        <importxlsx :loading="importLoading" :noraw="true" @onChange="handleImport"></importxlsx>
        <v-btn dark outline color="primary" @click="handleExportXlsx">
          <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="primary--text py-2">แคมเปญ: {{ campaign && campaign.name }}</div>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>{{ props.item.member_id }}</td>
          <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
          <td>{{ props.item.point }}</td>
          <td>{{ props.item.created_at | DateFormat('DD/MM/YYYY') }}</td>
          <td>
            <v-btn class="ma-0" icon fab outline small @click="handleEdit(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              class="ma-0"
              icon
              fab
              outline
              color="error"
              small
              @click="handleDelete(props.item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-xs-right mt-2">
      <v-pagination
        v-model="pageNumber"
        :total-visible="15"
        :length="pagelength"
        @input="handleChangePage"
      ></v-pagination>
    </div>

    <v-dialog v-model="showEditPoint" persistent width="300px">
      <v-card class="pa-2">
        <v-layout wrap>
          <v-flex xs12 sm12 class="form-control px-1" :class="{ 'has-error': errors.has('point') }">
            <div class="caption mb-1">คะแนน <span class="red--text">*</span></div>
            <input
              v-model="input.point"
              v-validate="'required'"
              type="text"
              data-vv-as="คะแนน"
              class="form-control"
              maxlength="255"
              name="point"
              style="width: 100%"
            />
            <p v-if="errors.has('point')" class="text-error">
              {{ errors.first('point') }}
            </p>
          </v-flex>
        </v-layout>
        <div class="text-xs-center mt-3">
          <v-btn outline color="grey" :loading="saveLoading" @click="handleCloseEditPoint">{{
            $t('cancel')
          }}</v-btn>
          <v-btn color="primary" depressed :loading="saveLoading" @click="handleSavePoint">{{
            $t('Save')
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  components: {
    importxlsx,
    exportxlsx
  },
  props: ['value'],
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      items: [],
      exportloading: false,
      headers: [
        { text: 'รหัสสมาชิก', value: 'member_id', sortable: false },
        { text: 'ชื่อสมาชิก', value: 'first_name', sortable: false },
        { text: 'คะแนน', value: 'point', sortable: false },
        { text: 'วันที่ได้รับคะแนน', value: 'created_at', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      campaign: null,
      isExport: false,
      importLoading: false,
      selectedEditData: null,
      input: {
        point: ''
      },
      showEditPoint: false,
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    if (this.value) {
      this.campaign = this.value
      this.handleGetCampaignMember()
    }
  },
  methods: {
    async handleGetCampaignMember() {
      const vm = this
      try {
        const response = await vm.getCampaignMember()
        if (response && response.status === 200) {
          vm.items = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getCampaignMember() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        const campaignId = vm.campaign.id

        vm.$store.dispatch('loading')
        const response = await toaCrmApi.getCampaignMember({ config: { params: data } }, campaignId)
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getCampaignMember()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            campaign: vm.campaign.name,
            member_id: el.member_id,
            name: `${el.first_name} ${el.last_name}`,
            point: el.point,
            created_at: moment(el.created_at).format('DD/MM/YYYY')
          }
        })

        const heading = [['แคมเปญ', 'รหัสสมาชิก', 'ชื่อสมาชิก', 'คะแนน', 'วันที่ได้รับคะแนน']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `campaign-member-list.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    transformHeaderField(data) {
      const result = []
      try {
        data.forEach((item) => {
          const tempItem = {
            member_id: '',
            point: ''
          }

          Object.keys(item).forEach((element) => {
            switch (element) {
              case 'รหัสสมาชิก':
                tempItem.member_id = item[element]
                break
              case 'จำนวนคะแนน':
                tempItem.point = item[element]
                break
              default:
              // code block
            }
          })
          result.push(tempItem)
        })
        return result
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async handleImport(item) {
      const vm = this
      try {
        const campaignId = vm.campaign.id
        const data = {
          campaign_id: campaignId,
          page_id: vm.selectedBot.pageid,
          data: vm.transformHeaderField(item[0])
        }

        vm.importLoading = true
        const response = await toaCrmApi.importPoint({ data })
        vm.importLoading = false

        if (response && response.status === 200) {
          await vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.handleGetCampaignMember()
        } else {
          await vm.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
        return
      }
    },
    async getTemplateCampaignMember() {
      try {
        const data = {
          page_id: this.selectedBot.pageid,
          limit: 5000,
          offset: 0
        }
        const response = toaCrmApi.getTemplateCampaignMember({
          config: {
            params: data
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async downloadImportTemplate() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getTemplateCampaignMember()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            id: el.id,
            name: el.name,
            point: ''
          }
        })

        const heading = [['รหัสสมาชิก', 'ชื่อสมาชิก', 'จำนวนคะแนน']]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `template-import-point.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetCampaignMember()
      }
    },
    async handleDelete(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          icon: 'error',
          text: `คุณต้องการลบคะแนนของ ${item.first_name} ${item.last_name} ใช่หรือไม่ ?`,
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          const data = {
            id: item.id,
            pageId: vm.selectedBot.pageid
          }

          vm.$store.dispatch('loading')
          const response = await vm.deleteCampaignMember(data)
          vm.$store.dispatch('loading')

          if (response && response.status === 200) {
            vm.handleGetCampaignMember()
          }
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async deleteCampaignMember(data) {
      try {
        const response = await toaCrmApi.deleteCampaignMember({ config: data })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    handleEdit(item) {
      this.selectedEditData = item
      this.input.point = item.point
      this.showEditPoint = true
    },
    async handleSavePoint() {
      const vm = this
      try {
        const data = {
          point: vm.input.point,
          id: vm.selectedEditData.id,
          pageId: vm.selectedBot.pageid
        }

        vm.saveLoading = true
        const response = await vm.updatePoint(data)
        vm.saveLoading = false

        if (response && response.status === 200) {
          vm.handleCloseEditPoint()
          vm.handleGetCampaignMember()
        }
      } catch (error) {
        vm.saveLoading = false
        console.error(error)
      }
    },
    handleCloseEditPoint() {
      this.selectedEditData = null
      this.input.point = ''
      this.showEditPoint = false
    },
    async updatePoint(data) {
      try {
        const response = toaCrmApi.updateCampaignMemberPoint({ config: data })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/CampaignMemberList.vue